import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface NewNoteCardProps {
  /** Click handler — pages wire to their respective create flow
   *  (project page = direct create + navigate; workspace page =
   *  pick-a-project popover). */
  onClick: () => void;
  /** When true, the button visually disables itself + ignores click.
   *  Used to gate during in-flight create mutations. */
  disabled?: boolean;
}

/**
 * Notes redesign — the dashed inline "+ New note" tile that lives at
 * the end of the cards grid (Q10). Direct port of the prototype's
 * `.v1-note-new` styling. Renders as a square-ish dashed card sized
 * to fit the grid template's `minmax(300px, 1fr)` cell.
 *
 * Only meaningful in the cards layout; the rows + pinboard layouts
 * suppress it because their item rendering doesn't tile uniformly
 * with the new-tile shape.
 */
export const NewNoteCard = ({ onClick, disabled = false }: NewNoteCardProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={cn(
      'flex min-h-[132px] flex-col items-center justify-center gap-1.5 rounded-xl border border-dashed bg-transparent p-4 text-[12px] transition-all duration-100',
      'border-[var(--glass-card-border)] text-foreground-muted',
      'hover:text-foreground hover:border-foreground-faint hover:bg-[var(--glass-card-bg)]',
      'disabled:cursor-not-allowed disabled:opacity-50',
      // Brand-accent on hover for the icon (matches prototype's
      // `:hover svg` rule).
      '[&:hover_svg]:text-[var(--brand-accent)]',
      'group',
    )}
  >
    <Plus className="text-foreground-faint size-4 transition-colors duration-100" />
    Add note
  </button>
);
